import { Directive, HostListener, ElementRef, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[cmDragAndDrop]'
})
export class DragAndDropDirective implements AfterViewInit {
  @Input() cmDragAndDrop: string;

  @Output() private filesChangeEmiter: EventEmitter<FileList> = new EventEmitter();

  constructor(private elRef: ElementRef) {
  }

  ngAfterViewInit() {
    this.addDragEventsToChildElement();
  }

  // if drag container has inner html elements we need to set drag events for inner/child elements
  // without this we lose drag class when user drag over inner html element. This work only for fist level child
  addDragEventsToChildElement() {
    this.elRef.nativeElement.childNodes.forEach(node => {
      node.ondragover = () => { this.addHoverClass(); };
      node.ondrop = () => { this.removeHoverClass();  };
    });
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.filesChangeEmiter.emit(files);
    }
    this.removeHoverClass();
  }

  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    this.addHoverClass();
    evt.preventDefault();
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    this.removeHoverClass();
  }

  addHoverClass() {
    if (this.cmDragAndDrop && !this.elRef.nativeElement.className.includes(' ' + this.cmDragAndDrop)) {
      this.elRef.nativeElement.className += ' ' + this.cmDragAndDrop;
    }
  }

  removeHoverClass() {
    if (this.cmDragAndDrop) {
      const reg = new RegExp(' ' + this.cmDragAndDrop, 'g');
      this.elRef.nativeElement.className = this.elRef.nativeElement.className.replace(reg, '');
    }
  }

}
